import {Button, Col, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {postPayment, postTicketCreate} from "connection/backend";
import SweetAlert from "react-bootstrap-sweetalert";
import Loader from "../../../components/Common/Loader";

const SummaryModal = (props) => {
  const year = new Date().getFullYear();
  const consecutive_year = String(year).slice(-2);

  const history = useHistory();
  const redirect = () => {
    history.push("/tickets");
  };

  const [loading, setLoading] = useState(false);
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [value, setValue] = useState("");
  const [payment_date, setPaymentDate] = useState("");
  const [payment_type, setPaymentType] = useState("2");
  const [payment_number, setPaymentNumber] = useState("");
  const [formData, setFormData] = useState({
    payment_method: "efectivo",
    bank: "banco_1"
  });
  const { payment_method, bank} = formData;

  const onChange = (e) => {
    if (e.target.name === "value") {
      let valor = e.target.value;
      const formattedValue = valor
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      const debt = parseInt(props.ticketData.total) - parseInt(props.ticketData.value_paid);
      if (parseInt(formattedValue.replace(/\./g, "")) > debt){
        const debt_string = String(debt);
        let debt_value = debt_string
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        setValue(debt_value);
      } else {
        setValue(formattedValue);
      }
    } else if (e.target.name === "payment_date") {
      setPaymentDate(e.target.value);
    } else if (e.target.name === "payment_type") {
      setPaymentType(e.target.value);
    } else if (e.target.name === "payment_number") {
      setPaymentNumber(e.target.value);
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      client_code: props.ticketData.client.code,
      ticket: props.ticketData.code,
      payment_method: payment_method,
      payment_date: payment_method !== "efectivo" ? payment_date : "2000-01-01",
      payment_type: payment_method !== "efectivo" ? payment_type : "1",
      payment_number: payment_number,
      bank: payment_method !== "efectivo" ? bank : "no_aplica",
      value: parseInt(value.replace(/\./g, ""))
    };
    postPay(data);
  };

  const postPay = async (data) => {
    setLoading(true);
    const response = await postPayment(data);
    if (response.status === 201){
      setAlertSuccess(true);
    } else {
      setAlertError(true);
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        centered={true}
        backdrop="static"
        size="lg"
      >
        <ModalHeader>Resumen de entrada</ModalHeader>
        <ModalBody>
          <>
            <Row className="d-flex justify-content-center mb-4">
              <Col lg={4} className="d-flex justify-content-center font-size-16">
                <b>Consecutivo: {consecutive_year} -</b>&nbsp;{props.ticketData.consecutive}
              </Col>
              <Col lg={4} className="d-flex justify-content-center font-size-16">
                <b>Código de ticket:</b>&nbsp;{props.ticketData.code}
              </Col>
              <Col lg={4} className="d-flex justify-content-center font-size-16">
                <b>Fecha:</b>&nbsp;{props.ticketData.created_date}
              </Col>
            </Row>
            <Row className="d-flex justify-content-center mb-4">
              <Col lg={5} className="d-flex justify-content-center font-size-16">
                <b>Cliente:</b>&nbsp;{props.ticketData.client.code} - {props.ticketData.client.full_name}
              </Col>
              <Col lg={3} className="d-flex justify-content-center font-size-16">
                <b>Número de bovinos:</b>&nbsp;{props.ticketData.animal_number}
              </Col>
              <Col lg={3} className="d-flex justify-content-center font-size-16">
                <b>Total:</b>&nbsp;$ {props.ticketData.total.toLocaleString("es-CO")}
              </Col>
            </Row>
            <Row className="d-flex justify-content-center mb-4">
              <Col lg={4} className="d-flex justify-content-center font-size-16">
                <b>Estado de pago:</b>&nbsp;
                {props.ticketData.payment_status === "pendiente" ? (
                  <span
                    className={
                      "badge rounded-pill bg-warning bg-soft text-warning"
                    }
                  >
                    <b>Pendiente</b>
                  </span>
                ) : (
                  <span
                    className={
                      "badge rounded-pill bg-success bg-soft text-success"
                    }
                  >
                    <b>Pagado</b>
                  </span>
                )}
              </Col>
              <Col lg={4} className="d-flex justify-content-center font-size-16">
                <b>Valor pagado:</b>&nbsp;$ {props.ticketData.value_paid.toLocaleString("es-CO")}
              </Col>
            </Row>
            <hr/>
            {props.ticketData.payment_status === "pagado" ? (
              <>
                <Row>
                  <Col lg={12} className="d-flex justify-content-center">
                    <p><b>Detalle: </b>El ticket ha sido pagado con el saldo del cliente.</p>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} className="d-flex justify-content-end">
                    <Button color="secondary" onClick={() => redirect()}>
                      Cerrar
                    </Button>
                  </Col>
                </Row>
              </>
              ) : (
              <Form onSubmit={onSubmit}>
                <Row className="justify-content-md-center mb-2">
                  <Col lg={5} className="font-size-16 mb-2">
                    <b>Medio de pago: </b>
                    <select
                      className="form-select"
                      id="payment_method"
                      name="payment_method"
                      value={payment_method}
                      onChange={onChange}
                    >
                      <option value="efectivo">Efectivo</option>
                      <option value="consignacion">Consignación</option>
                      <option value="cheque">Cheque</option>
                    </select>
                  </Col>
                  {payment_method !== "efectivo" ? (
                    <>
                      <Col lg={5} className="font-size-16">
                        <b>Entidad: </b>
                        <select
                          className="form-select"
                          id="bank"
                          name="bank"
                          value={bank}
                          onChange={onChange}
                        >
                          <option value="banco_1">Banco de Bogotá</option>
                          <option value="banco_2">Bancolombia</option>
                        </select>
                      </Col>
                      <Col lg={5} className="font-size-16">
                        <b>Fecha de consignación: </b>
                        <Input
                          type="date"
                          id="payment_date"
                          name="payment_date"
                          value={payment_date}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={5} className="font-size-16">
                        <b>Tipo: </b>
                        <select
                          className="form-select"
                          id="payment_type"
                          name="payment_type"
                          value={payment_type}
                          onChange={onChange}
                        >
                          <option value="2">Consignación corresponsal bancario</option>
                          <option value="3">Transferencia cta Sucursal Virtual</option>
                          <option value="4">Transferencia Nequi</option>
                          <option value="5">Transferencia Banca Móvil</option>
                        </select>
                      </Col>
                      <Col lg={5} className="font-size-16">
                        <b>Número de recibo: </b>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Ingrese el valor..."
                          name="payment_number"
                          id="payment_number"
                          value={payment_number}
                          onChange={onChange}
                          required
                        />
                      </Col>
                    </>
                  ) : null}
                  <Col lg={5} className="font-size-16">
                    <b>Abono: </b>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Ingrese el valor..."
                      name="value"
                      id="value"
                      value={value}
                      onChange={onChange}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} className="d-flex justify-content-end">
                    <Button
                      color="primary"
                      className="btn me-2"
                      type="submit"
                    >
                      Registrar abono
                    </Button>
                    <Button color="secondary" onClick={() => redirect()}>
                      Cerrar
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </>
        </ModalBody>
      </Modal>
      {/* Alerts */}
      <SweetAlert
        title="¡Hecho!"
        success
        showConfirm={true}
        show={alertSuccess}
        onConfirm={() => {
          redirect();
        }}
      >
        El abono/pago del ticket se ha registrado correctamente.
      </SweetAlert>
      <SweetAlert
        title="¡Error!"
        danger
        showConfirm={true}
        show={alertError}
        onConfirm={() => {
          setAlertError(false);
        }}
      >
        Ocurrió un error al registrar el pago, intente nuevamente.
      </SweetAlert>
    </>
  )
};

export default SummaryModal;
